import constate from "constate";
import { useRef } from "react";

/**
 * Hook to manage the modals container ref.
 * This ref is in Drawer components to scope them to a specific container.
 */
function useModalsContainer() {
  const containerRef = useRef<HTMLElement>();

  return { containerRef };
}

export const [ModalsContainerProvider, useModalsContainerContext] = constate(useModalsContainer);
